import { WithHeader } from "@Light/components/page/header";
import { useHeaderRightButton } from "@Light/components/page/header/context";
import { Overlay } from "@Light/components/page/Overlay";
import { SupportBottomSheetProvider } from "@Light/components/page/SupportBottomSheet";
import { Navigate, Route, Routes } from "react-router-dom";
import { CheckEmail } from "./CheckEmail";
import { Login } from "./Login";
import { LoginToken } from "./LoginToken";

export type LoginRoutesProps = {};

export const LoginRoutes: React.FC<LoginRoutesProps> = ({}) => {
  return (
    <LoginLayout>
      <Routes>
        <Route path="" element={<Login />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="/token" element={<LoginToken />} />
        <Route path="/*" element={<Navigate to="/login" />} />
      </Routes>
    </LoginLayout>
  );
};

export type LoginLayoutProps = {
  children: React.ReactNode;
};

export const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  return (
    <Overlay>
      <SupportBottomSheetProvider>
        <WithHeader>
          <LoginLayoutWithHeader>{children}</LoginLayoutWithHeader>
        </WithHeader>
      </SupportBottomSheetProvider>
    </Overlay>
  );
};

const LoginLayoutWithHeader: React.FC<LoginLayoutProps> = ({ children }) => {
  useHeaderRightButton(<div />);
  return children;
};
